import { DefaultEvent } from "./default.event";

// This event is being dispatched whenever HTTPInterceptor encounters
// 401 response
export class UnauthorizedAccessEvent extends DefaultEvent {
  constructor() {
    super({});
  }
}


// WEBPACK FOOTER //
// ./client/app/shared/event/unauthorized-access.event.js